import { Alert } from 'foundations-components/transitional/components/Alert';
import I18n from 'I18n';
import { connect } from 'react-redux';
import { hideTokenExpiredAlert as hideTokenExpiredAlertAction } from 'LoginUI/actions';
import { getIsTokenExpiredAlertVisible } from 'LoginUI/selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const TokenExpiredAlert = ({
  isTokenExpiredAlertVisible,
  hideTokenExpiredAlert
}) => {
  if (!isTokenExpiredAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: I18n.text('login.twoFactor.errors.tokenExpired.title'),
    closeable: true,
    onClose: hideTokenExpiredAlert,
    children: I18n.text('login.twoFactor.errors.tokenExpired.body')
  });
};
const mapStateToProps = state => ({
  isTokenExpiredAlertVisible: getIsTokenExpiredAlertVisible(state)
});
export default connect(mapStateToProps, {
  hideTokenExpiredAlert: hideTokenExpiredAlertAction
})(TokenExpiredAlert);